module.exports = __webpack_public_path__ + "img/flag.c5ff4ced.svg";